import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import authModule from './auth/auth.module';
import mutationTypes from './popupTypes';
import dashModule from './dash/dash.module';
import supportersModule from './supporters/supporters.module';
import tiersModule from './tiers/tiers.module';
import todosModule from './todos/todos.module';
import actionsModule from './actions/actions.module';
import ctaModule from './cta/cta.module';
import activitiesModule from './activities/activities.module';
import managerModule from './manager/manager.module';
import settingModule from './setting/setting.module';


Vue.use(Vuex);
export default new Store({
  state: {
    isShowPopupBox: false,
    isShowHome: false,
    exitShown: false,
    loggedIn: false,
    open: false,
    showGifts: true,
    showDonation: false,
    showPaymentSuccessfull: false,
    showContinue: false
  },
  mutations: {
    [mutationTypes.TOGGLE_POPUP_BOX](states, payload) {
      states.isShowPopupBox = payload;
    },
    [mutationTypes.TOGGLE_HOME](states, payload) {
      states.isShowHome = payload;
    },
    [mutationTypes.TOGGLE_EXIT_SHOWN](states, payload) {
      states.exitShown = payload;
    },
    [mutationTypes.TOGGLE_LOGIN](states, payload) {
      states.loggedIn = payload;
    },
    [mutationTypes.TOGGLE_OPEN](states, payload) {
      states.open = payload;
    }
  },
  modules: {
    auth: authModule,
    dash: dashModule,
    supporters: supportersModule,
    tiers: tiersModule,
    actions: actionsModule,
    cta: ctaModule,
    activities: activitiesModule,
    manager: managerModule,
    todos: todosModule,
    setting: settingModule
  }
});
